import React, { FC } from 'react'
import {
  TextInput,
  Create,
  SimpleForm,
  required,
  CreateProps,
  SelectInput,
} from 'react-admin'

import { makeStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'

import { DatetimePicker, Tooltip } from 'components'

const useStyles = makeStyles({
  container: {
    padding: 8,
  },

  formContainer: {
    backgroundColor: '#F5F5F5',
    padding: 0,
    justifyContent: 'center',
  },

  gridContainer: {
    width: '100%',
    margin: 0,
    padding: 0,
  },

  noPadding: {
    padding: 0,
  },

  paperContainer: {
    padding: 16,
  },

  row: {
    width: '100%',
  },
})

export const CreateUser: FC<CreateProps> = (props: any) => {
  const classes = useStyles()

  return (
    <Create className={classes.container} {...props}>
      <SimpleForm
        warnWhenUnsavedChanges
        className={classes.formContainer}
        initialValues={{
          ms1_access_level: 'TI',
          name: '',
          gender: '',
          email: '',
          password: '',
          phone: '',
          document: '',
          cpf: '',
          country: '',
          zip_code: '',
          street: '',
          number: '',
          complement: '',
          district: '',
          province: '',
          city: '',
        }}
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
          className={classes.gridContainer}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Paper className={classes.paperContainer}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  Inserir Novo Usuário
                </Typography>

                <hr />

                <Typography
                  variant="subtitle1"
                  color="textPrimary"
                  gutterBottom
                >{`Informações básicas: `}</Typography>
              </Grid>

              <Grid
                container
                spacing={2}
                className={classes.gridContainer}
                direction="column"
              >
                <Grid container spacing={2} className={classes.gridContainer}>
                  <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                    <Tooltip title={'users.ms1_access_level'}>
                      <SelectInput
                        fullWidth
                        label="Tipo do usuário"
                        source={'ms1_access_level'}
                        choices={[
                          { id: 'Assinante', name: 'Assinante' },
                          { id: 'Bloqueado', name: 'Bloqueado' },
                          { id: 'CMS', name: 'CMS' },
                          { id: 'TI', name: 'T.I.' },
                          { id: 'freeUser', name: 'Livre acesso' },
                          { id: 'Administrador', name: 'Administrador' },
                        ]}
                        validate={[required('Obrigatório')]}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>

                <Grid container spacing={2} className={classes.gridContainer}>
                  <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                    <Tooltip title={'users.ms1_access_status'}>
                      <SelectInput
                        fullWidth
                        label="Status do Usuário"
                        source={'ms1_access_status'}
                        choices={[
                          { id: 'ATIVO', name: 'Ativo' },
                          { id: 'BLOQUEADO', name: 'Bloqueado' },
                        ]}
                        validate={[required('Obrigatório')]}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>

                <Grid container spacing={2} className={classes.gridContainer}>
                  <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                    <Tooltip title={'users.ms1_cancel_requested_at'}>
                      <DatetimePicker
                        fullWidth
                        source="ms1_cancel_requested_at"
                        label="Cancelar em"
                      />
                    </Tooltip>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.noPadding}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Tooltip title={'users.name'}>
                        <TextInput
                          fullWidth
                          label="Nome"
                          source="name"
                          validate={[required('Obrigatório')]}
                        />
                      </Tooltip>
                    </Grid>

                    <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                      <Tooltip title={'users.gender'}>
                        <SelectInput
                          fullWidth
                          label="Gênero"
                          source={'gender'}
                          choices={[
                            { id: 'Feminino', name: 'Feminino' },
                            { id: 'Masculino', name: 'Masculino' },
                            { id: 'Não binário', name: 'Não-binário' },
                          ]}
                          validate={[required('Obrigatório')]}
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'users.email'}>
                    <TextInput
                      fullWidth
                      label="Email"
                      source="email"
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                      <Tooltip title={'users.password'}>
                        <TextInput
                          fullWidth
                          label="Senha"
                          source="password"
                          validate={[required('Obrigatório')]}
                        />
                      </Tooltip>
                    </Grid>

                    <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                      <Tooltip title={'users.phone'}>
                        <TextInput
                          fullWidth
                          label="Telefone"
                          source="phone"
                          validate={[required('Obrigatório')]}
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'users.cpf'}>
                    <TextInput
                      fullWidth
                      label="CPF/Documento"
                      source="cpf"
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>

                {/* ################################################################# */}

                <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
                  <hr />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography
                    variant="subtitle1"
                    color="textPrimary"
                    gutterBottom
                  >{`Endereço: `}</Typography>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Tooltip title={'users.country'}>
                        <TextInput fullWidth label="País" source="country" />
                      </Tooltip>
                    </Grid>

                    <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                      <Tooltip title={'users.zip_code'}>
                        <TextInput
                          fullWidth
                          label="CEP/ZIP code"
                          source="zip_code"
                          validate={[required('Obrigatório')]}
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Tooltip title={'users.street'}>
                        <TextInput fullWidth label="Endereço" source="street" />
                      </Tooltip>
                    </Grid>

                    <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                      <Tooltip title={'users.number'}>
                        <TextInput fullWidth label="Número" source="number" />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                      <Tooltip title={'users.complement'}>
                        <TextInput
                          fullWidth
                          label="Complemento"
                          source="complement"
                        />
                      </Tooltip>
                    </Grid>

                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                      <Tooltip title={'users.district'}>
                        <TextInput fullWidth label="Bairro" source="district" />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'users.province'}>
                    <TextInput fullWidth label="Estado" source="province" />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'users.city'}>
                    <TextInput fullWidth label="Cidade" source="city" />
                  </Tooltip>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  )
}
